module.exports = __webpack_public_path__ + "static/img/recommend-list-2.48e0ea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-2.png
// module id = A+pT
// module chunks = 1